import { BuiltFieldAttributes } from './baseFieldBuilder'

export default function ratingFieldBuilder(): Partial<BuiltFieldAttributes> {
  return {
    ratingType: 'star',
    ratingMax: 5,
  }
}
